import React  from 'react';
import { Home } from "./MyPages/Home";
import { PageNotFound } from "./MyPages/PageNotFound";
import { Contact } from "./MyPages/Contact";
import { Cv } from "./MyPages/Cv";
import { Project } from "./MyPages/Project";
import { Header } from "./MyComponents/Header";
import { Footer } from "./MyComponents/Footer";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <>
      <Router>
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />}></Route>
          <Route exact path="/contact" element={<Contact />}></Route>
          <Route exact path="/cv" element={<Cv />}></Route>
          <Route exact path="/project" element={<Project />}></Route>
          <Route path="*" element={<PageNotFound/>} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
